import colors from "../../base/colors";
import typography from "../../base/typography";

import pxToRem from "../../functions/pxToRem";

const { background, text } = colors;
const { size, fontWeightBold } = typography;

const tableHead = {
  styleOverrides: {
    root: {
      backgroundColor: background.sectionAlt,
      "& .MuiTableCell-head": {
        color: text.primary,
        fontSize: size.sm,
        fontWeight: fontWeightBold,
        borderBottom: `1px solid ${colors.divider}`,
        padding: `${pxToRem(10)} ${pxToRem(14)}`,
      },
    },
  },
};

export default tableHead;
